const LOGO_URL = "/logo-white.png";

export const Logo = ({ className = "" }) => (
  <img
    src={LOGO_URL}
    alt="Birrificio Vecchio Cinghiale"
    className={`h-11 md:h-12 w-auto object-contain ${className}`}
    data-testid="brand-logo"
  />
);
